import { DUMMY_IMG_URL, PSP_TYPES } from 'configs/constants';

export const getProviderImageURL = (pspType, customerInfoMasked) => {
  const cardTypeImages = {
    3: 'img/provider-icons/Amex_logo.svg#svgView(viewBox(350,-80,200,500))',
    4: 'img/provider-icons/Visa_logo.svg#svgView(viewBox(350,-80,200,500))',
    5: 'img/provider-icons/Mastercard_logo.svg#svgView(viewBox(350,-80,200,500))',
    default: 'img/provider-icons/creditcard.svg',
  };

  const firstChar = customerInfoMasked?.charAt(0);

  if (pspType === PSP_TYPES.PLANETPAYMENT.value || pspType === PSP_TYPES.STRIPE.value) {
    return cardTypeImages[firstChar] || cardTypeImages.default;
  }

  const providerImages = {
    [PSP_TYPES.PLANETPAYMENT.value]: 'img/provider-icons/planet_logo.svg#svgView(viewBox(350,-80,200,500))',
    [PSP_TYPES.STRIPE.value]: 'img/provider-icons/Stripe_logo.svg#svgView(viewBox(350,-80,200,500))',
    [PSP_TYPES.SWISH.value]: 'img/provider-icons/swish.svg',
    [PSP_TYPES.BLUECODE.value]: 'img/provider-icons/bluecode.svg',
    [PSP_TYPES.CREDITCARD.value]: 'img/provider-icons/worldline-logo.svg',
    [PSP_TYPES.ACCESSTOKEN.value]: 'img/provider-icons/RFID_logo.svg#svgView(viewBox(350,-80,200,500))',
    [PSP_TYPES.BINANCE.value]: 'img/provider-icons/binance.svg',
    [PSP_TYPES.VIPPS.value]: 'img/provider-icons/vipps.svg',
    [PSP_TYPES.MOBILEPAY.value]: 'img/provider-icons/mobilepay.png',
    [PSP_TYPES.HUBJECT.value]: 'img/provider-icons/hubject-logo-light.svg',
    [PSP_TYPES.EASYPARK.value]: 'img/provider-icons/easypark-logo_colored.svg',
    [PSP_TYPES.NORTHE.value]: 'img/provider-icons/Logo_Northe.svg',
    [PSP_TYPES.VOLVO.value]: 'img/provider-icons/Logo_volvo.svg',
    [PSP_TYPES.BOSCH.value]: 'img/provider-icons/Bosch-logo.svg',
    [PSP_TYPES.GITO.value]: 'img/provider-icons/Logo_gito.svg',
    [PSP_TYPES.ADYEN.value]: 'img/provider-icons/Logo_Adyen.svg',
    [PSP_TYPES.TWINT.value]: 'img/provider-icons/twint-logo.svg',
  };

  return providerImages[pspType] || DUMMY_IMG_URL;
};
